export const PARTIAL_TRANSACTIONS_NOTICE =
  'Some transactions could not be fully loaded, so this list may be incomplete.'

export const PARTIAL_LIQUIDATIONS_NOTICE =
  'Some liquidations could not be loaded, so this list may be incomplete.'
